import CheckmateApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();


const useGetSameCaseKey = 'check-case-same-case';

export const useCheckCaseSameCase = (caseGuid: string | undefined) => {
    return useQuery({
        queryKey: [useGetSameCaseKey, caseGuid],
        queryFn: async () => {
            if (!caseGuid) {
                return;
            }

            const response = await _apiClient.checkCaseSameCase(caseGuid);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the cases for this same case.');
            }

            return response.payload;
        },
        enabled: !!caseGuid,
        cacheTime: 0,
        staleTime: 0,
    });
};
